import MainLayout from '@theme/components/MainLayout';
import PostList from '@theme/components/PostList';
import Pagination from '@theme/components/Pagination';
import CategoriesBar from '@theme/components/CategoriesBar';
export default {
  data() {
    return {
      category: '',
      total: 0,
      // 总长
      perPage: 10,
      // 每页长
      currentPage: 1 // 当前页
    };
  },
  components: {
    MainLayout,
    PostList,
    Pagination,
    CategoriesBar
  },
  mounted() {
    const queryCategory = this.$route.query.category;
    if (queryCategory) {
      this.category = queryCategory;
      this.total = this.$groupPosts.categories[queryCategory].length;
    } else {
      this.total = this.$sortPosts.length;
    }
    if (this.$route.query.p) {
      this.currentPage = Number(this.$route.query.p);
    }

    // 滚动条定位到当前分类（增强用户体验）
    const cateEl = document.querySelector('.categories');
    if (cateEl) {
      setTimeout(() => {
        const activeEl = cateEl.querySelector('.active');
        const topVal = activeEl ? activeEl.offsetTop : 0;
        cateEl.scrollTo({
          top: topVal,
          behavior: 'smooth'
        });
      }, 300);
    }
  },
  methods: {
    handlePagination(i) {
      // 分页
      this.currentPage = i;
    }
  },
  watch: {
    '$route.query.category'(category) {
      this.category = category ? decodeURIComponent(category) : '';
      if (this.category) {
        this.total = this.$groupPosts.categories[this.category].length;
      } else {
        this.total = this.$sortPosts.length;
      }
      this.currentPage = 1;
    }
  }
};